import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./index.css";

const CookieConsent = () => {
  const { t } = useTranslation();
  const [showBanner, setShowBanner] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setTimeout(() => {
        setShowBanner(true);
      }, 500);
    } else {
      try {
        const savedPrefs = JSON.parse(consent);
        setPreferences(savedPrefs);
      } catch (e) {
        console.error("Error loading cookie preferences:", e);
      }
    }

    const handleOpenSettings = () => {
      setShowSettings(true);
      setShowBanner(true);
    };

    window.addEventListener("openCookieSettings", handleOpenSettings);
    return () => window.removeEventListener("openCookieSettings", handleOpenSettings);
  }, []);

  const savePreferences = (prefs) => {
    localStorage.setItem("cookieConsent", JSON.stringify(prefs));
    localStorage.setItem("cookieConsentDate", new Date().toISOString());
    setPreferences(prefs);
    setShowBanner(false);
    setShowSettings(false);
    window.dispatchEvent(new CustomEvent("cookieConsentUpdated", { detail: prefs }));
  };

  const handleAcceptAll = () =>
    savePreferences({ necessary: true, analytics: true, marketing: true });

  const handleRejectAll = () =>
    savePreferences({ necessary: true, analytics: false, marketing: false });

  const handleSavePreferences = () => savePreferences(preferences);

  const togglePreference = (key) => {
    if (key === "necessary") return;
    setPreferences((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  if (!showBanner) return null;

  return (
    <div
      className="cookie-consent-overlay"
      onClick={() => !showSettings && setShowBanner(false)}
    >
      <div className="cookie-consent-modal" onClick={(e) => e.stopPropagation()}>
        {!showSettings ? (
          <>
            <div className="cookie-consent-content">
              <h3 className="cookie-consent-title">{t("cookie_title")}</h3>
              <p className="cookie-consent-text">{t("cookie_description")}</p>
              <p className="cookie-consent-text">{t("cookie_description_2")}</p>
            </div>
            <div className="cookie-consent-buttons">
              <button
                type="button"
                className="cookie-consent-btn cookie-consent-btn-secondary"
                onClick={handleRejectAll}
              >
                {t("cookie_reject_all")}
              </button>
              <button
                type="button"
                className="cookie-consent-btn cookie-consent-btn-link"
                onClick={() => setShowSettings(true)}
              >
                {t("cookie_customize")}
              </button>
              <button
                type="button"
                className="cookie-consent-btn cookie-consent-btn-primary"
                onClick={handleAcceptAll}
              >
                {t("cookie_accept_all")}
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="cookie-consent-content">
              <h3 className="cookie-consent-title">
                {t("cookie_customize_title")}
              </h3>
              <p className="cookie-consent-text">
                {t("cookie_customize_description")}
              </p>

              <div className="cookie-consent-categories">
                <div className="cookie-consent-category">
                  <div className="cookie-consent-category-header">
                    <div>
                      <h4 className="cookie-consent-category-title">
                        {t("cookie_necessary_title")}
                      </h4>
                      <p className="cookie-consent-category-desc">
                        {t("cookie_necessary_description")}
                      </p>
                    </div>
                    <label className="cookie-consent-toggle">
                      <input
                        type="checkbox"
                        checked={preferences.necessary}
                        disabled
                        readOnly
                      />
                      <span className="cookie-consent-slider"></span>
                    </label>
                  </div>
                </div>

                <div className="cookie-consent-category">
                  <div className="cookie-consent-category-header">
                    <div>
                      <h4 className="cookie-consent-category-title">
                        {t("cookie_analytics_title")}
                      </h4>
                      <p className="cookie-consent-category-desc">
                        {t("cookie_analytics_description")}
                      </p>
                    </div>
                    <label className="cookie-consent-toggle">
                      <input
                        type="checkbox"
                        checked={preferences.analytics}
                        onChange={() => togglePreference("analytics")}
                      />
                      <span className="cookie-consent-slider"></span>
                    </label>
                  </div>
                </div>

                <div className="cookie-consent-category">
                  <div className="cookie-consent-category-header">
                    <div>
                      <h4 className="cookie-consent-category-title">
                        {t("cookie_marketing_title")}
                      </h4>
                      <p className="cookie-consent-category-desc">
                        {t("cookie_marketing_description")}
                      </p>
                    </div>
                    <label className="cookie-consent-toggle">
                      <input
                        type="checkbox"
                        checked={preferences.marketing}
                        onChange={() => togglePreference("marketing")}
                      />
                      <span className="cookie-consent-slider"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="cookie-consent-buttons">
              <button
                type="button"
                className="cookie-consent-btn cookie-consent-btn-secondary"
                onClick={() => {
                  setShowSettings(false);
                  if (!localStorage.getItem("cookieConsent")) setShowBanner(false);
                }}
              >
                {t("cookie_cancel")}
              </button>
              <button
                type="button"
                className="cookie-consent-btn cookie-consent-btn-primary"
                onClick={handleSavePreferences}
              >
                {t("cookie_save_preferences")}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CookieConsent;

